import React from "react";
import TrafficMessage from "../../../../SharedComponents/TrafficMessage/TrafficMessage";
import { useSelector } from "react-redux";
import Table from "components/Table";

const AffiliateTable = () => {
	const affiliatesData = useSelector(state => state.sessionAffiliates.data.perdayData);

	const formatData = () => {
		// Aggregate counts across all dates and affiliates
		const resultMap = {};
		let id = 0;

		if (!affiliatesData) return [];

		Object.values(affiliatesData).forEach(day => {
			const bot = day.bot || {};
			const human = day.human || {};

			// combine keys from bot and human (skip totals)
			Object.keys({ ...bot, ...human }).forEach(affiliateKey => {
				if (affiliateKey === 'total') return;
				const name = (affiliateKey === 'null' || affiliateKey === 'No Affiliate') ? 'No Affiliate' : affiliateKey;
				// exclude No Affiliate entries
				if (name === 'No Affiliate') return;
				const botCount = bot[affiliateKey] || 0;
				const humanCount = human[affiliateKey] || 0;

				if (!resultMap[name]) {
					resultMap[name] = { id: id++, affiliate: name, total_Bots: 0, total_Humans: 0 };
				}
				resultMap[name].total_Bots += botCount;
				resultMap[name].total_Humans += humanCount;
			});
		});

		const result = Object.values(resultMap).map(item => {
			const bots = item.total_Bots;
			const humans = item.total_Humans;
			const total = bots + humans;
			const bot_percentage = total > 0 ? ((bots / total) * 100).toFixed(1) + '%' : '0%';
			return { ...item, bot_percentage };
		});

		result.sort((a, b) => parseFloat(b.bot_percentage) - parseFloat(a.bot_percentage));
		return result;
	}
	const headers = [
		{ headerName: "Affiliate", field: 'affiliate' },
		{ headerName: "Total Humans", field: 'total_Humans' },
		{ headerName: "Total Bots", field: 'total_Bots' },
		{ headerName: "Bot Percentage", field: 'bot_percentage' }
	];

	const formattedData = formatData();
	
	return (
		<>
			{formattedData.length !== 0 ?
					<div className="table-container-parent">
						<Table
							headers={headers}
							data={formattedData}
						/>
					</div>
				:
				<div style={{ background: "white", position: "relative", minHeight: "30vh" }}>
					<TrafficMessage message="No affiliate traffic in the time period selected." />
				</div>
			}
		</>
	)
}

export default AffiliateTable;